import { render, staticRenderFns } from "./classify.vue?vue&type=template&id=085c97fa&scoped=true&"
import script from "./classify.vue?vue&type=script&lang=js&"
export * from "./classify.vue?vue&type=script&lang=js&"
import style0 from "./classify.vue?vue&type=style&index=0&id=085c97fa&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "085c97fa",
  null
  
)

export default component.exports